import { MapPin, Navigation } from "lucide-react";
import {
    COMPANY,
    COVERAGE_AREAS,
    IMAGES,
    NEIGHBOR_CITIES,
    buildWhatsAppLink,
} from "../../lib/constants";

export const Coverage = () => {
    return (
        <section
            id="cobertura"
            data-testid="coverage-section"
            className="bg-[#0a0a0a] text-white py-20 md:py-28 noise-bg relative overflow-hidden"
        >
            {/* Background image */}
            <div className="absolute inset-0 opacity-15">
                <img
                    src={IMAGES.coverage}
                    alt="Guincho RCM atuando em Praia Grande com prédios da orla ao fundo"
                    className="w-full h-full object-cover"
                />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/90 to-[#0a0a0a]/40" />

            <div className="container mx-auto px-4 md:px-8 relative z-10">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
                    <div>
                        <span className="text-xs font-bold tracking-[0.3em] uppercase text-[#f45100]">
                            · Regiões atendidas ·
                        </span>
                        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tight mt-3 leading-[0.95]">
                            Toda{" "}
                            <span className="text-[#f45100]">
                                Praia Grande
                            </span>{" "}
                            coberta — bairro por bairro.
                        </h2>
                        <p className="mt-5 text-white/70 text-base md:text-lg max-w-xl">
                            Nossas viaturas estão posicionadas em pontos
                            estratégicos da cidade para chegar até você no menor
                            tempo possível. Atendemos também as cidades vizinhas
                            da Baixada Santista.
                        </p>

                        <div className="mt-10">
                            <h3 className="text-xs font-bold tracking-[0.3em] uppercase text-[#f45100] mb-4">
                                Bairros de Praia Grande
                            </h3>
                            <div className="flex flex-wrap gap-2">
                                {COVERAGE_AREAS.map((area, i) => (
                                    <span
                                        key={i}
                                        data-testid={`coverage-area-${i}`}
                                        className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/5 border border-white/10 hover:border-[#f45100] hover:bg-[#f45100]/10 transition-all rounded-full text-xs font-medium"
                                    >
                                        <MapPin
                                            size={12}
                                            className="text-[#f45100]"
                                        />
                                        {area}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="mt-8">
                            <h3 className="text-xs font-bold tracking-[0.3em] uppercase text-[#f45100] mb-4">
                                Cidades vizinhas
                            </h3>
                            <div className="flex flex-wrap gap-2">
                                {NEIGHBOR_CITIES.map((city, i) => (
                                    <span
                                        key={i}
                                        className="px-3 py-1.5 bg-[#f45100]/15 border border-[#f45100]/40 rounded-full text-xs font-bold uppercase tracking-wide"
                                    >
                                        {city}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <a
                            href={buildWhatsAppLink(
                                "Olá! Quero confirmar se vocês atendem na minha região de Praia Grande",
                            )}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="coverage-whatsapp-btn"
                            className="mt-9 inline-flex items-center gap-2 px-6 py-4 bg-[#f45100] hover:bg-[#d14500] rounded-xl font-bold text-sm uppercase tracking-wider transition-all hover:scale-[1.02]"
                        >
                            <Navigation size={16} strokeWidth={2.5} />
                            Confirmar atendimento na minha rua
                        </a>
                    </div>

                    {/* Map */}
                    <div className="relative h-[400px] md:h-[560px] border-2 border-white/10 overflow-hidden">
                        <iframe
                            title="Mapa de cobertura RCM Guincho Express - Praia Grande"
                            data-testid="coverage-map"
                            src="https://www.google.com/maps?q=Praia+Grande,+SP&t=&z=12&ie=UTF8&iwloc=&output=embed"
                            width="100%"
                            height="100%"
                            style={{ border: 0, filter: "grayscale(0.4) contrast(1.1)" }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                        <div className="absolute top-4 left-4 bg-[#f45100] text-white px-4 py-2 font-bold text-xs uppercase tracking-wider shadow-2xl">
                            ● Atendendo em {COMPANY.city}/{COMPANY.state}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
